import { useEffect } from 'react'
import { track } from '../../lib/analytics'

interface MarketingSEOProps {
  title: string
  description: string
  path: string
  jsonLd?: Record<string, unknown> | Record<string, unknown>[]
}

import { SITE_URL } from './marketingData'

function setMeta(selector: string, attr: 'name' | 'property', key: string, content: string) {
  let meta = document.querySelector<HTMLMetaElement>(selector)
  if (!meta) {
    meta = document.createElement('meta')
    meta.setAttribute(attr, key)
    document.head.appendChild(meta)
  }
  meta.content = content
}

export function MarketingSEO({ title, description, path, jsonLd }: MarketingSEOProps) {
  const structuredData = jsonLd ? JSON.stringify(jsonLd) : null
  useEffect(() => {
    const url = `${SITE_URL}${path}`
    track('Marketing Page View')
    document.title = title
    setMeta('meta[name="robots"]', 'name', 'robots', 'index, follow')

    setMeta('meta[name="description"]', 'name', 'description', description)
    setMeta('meta[property="og:title"]', 'property', 'og:title', title)
    setMeta('meta[property="og:description"]', 'property', 'og:description', description)
    setMeta('meta[property="og:type"]', 'property', 'og:type', 'website')
    setMeta('meta[property="og:url"]', 'property', 'og:url', url)
    setMeta('meta[name="twitter:card"]', 'name', 'twitter:card', 'summary_large_image')
    setMeta('meta[name="twitter:title"]', 'name', 'twitter:title', title)
    setMeta('meta[name="twitter:description"]', 'name', 'twitter:description', description)

    let canonical = document.querySelector<HTMLLinkElement>('link[rel="canonical"]')
    if (!canonical) {
      canonical = document.createElement('link')
      canonical.rel = 'canonical'
      document.head.appendChild(canonical)
    }
    canonical.href = url

    document.querySelectorAll('script[type="application/ld+json"]').forEach(el => el.remove())
    if (structuredData) {
      const script = document.createElement('script')
      script.type = 'application/ld+json'
      script.dataset.autoaxxizJsonld = 'true'
      script.text = structuredData
      document.head.appendChild(script)
    }
  }, [title, description, path, structuredData])

  return null
}
